<template>
  <div class="chart">
    <h4>{{ title }}</h4>
    <p v-if="singleTotal && totals.subTotals[0]">Total {{ totals.subTotals[0].label }} {{ totals.grandTotal }}</p>
    <canvas ref="chart"></canvas>
    <div class="list-group list-group-flush" v-if="!singleTotal && showTotals">
      <template v-for="(total, i) in totals.subTotals">
        <p class="mb-0" :key="i">
          <strong>{{ total.label }}:</strong>
          {{ total.total }}
        </p>
      </template>
      <p><strong>Total:</strong> {{ totals.grandTotal }}</p>
    </div>
  </div>
</template>

<style>
canvas {
  max-width: 1024px;
}
</style>

<script>
import Chart from 'chart.js'

export default {
  name: 'Chart',
  props: {
    data: {
      type: Array
    },
    title: {
      type: String
    },
    showTotals: {
      type: Boolean,
      default () {
        return true
      }
    },
    singleTotal: {
      type: Boolean,
      default () {
        return false
      }
    },
    type: {
      type: String,
      default () {
        return 'bar'
      }
    }
  },
  computed: {
    labels () {
      return this.data[0].labels
    },
    dataSet () {
      let dataSet = []
      for (let { label, data, color } of this.data) {
        dataSet.push({
          label,
          data,
          backgroundColor: `rgba(${color}, 0.45)`,
          borderColor: `rgba(${color}, 1)`,
          borderWidth: 1
        })
      }
      return dataSet
    },
    totals () {
      let totals = {
        subTotals: [],
        grandTotal: 0
      }
      if (this.data.length > 0) {
        for (let { data, label } of this.data) {
          if (data) {
            let total = data.reduce((a, b) => parseFloat(a) + parseFloat(b), 0)
            totals.subTotals.push({ total, label })
            totals.grandTotal += parseFloat(total)
          }
        }
      }
      return totals
    }
  },
  data () {
    return {
      chart: false
    }
  },
  mounted () {
    this.chart = new Chart(this.$refs.chart, {
      type: this.type,
      data: {
        labels: [],
        datasets: this.dataSet
      },
      options: {
        legend: {
          position: 'bottom'
        },
        tooltips: {
          mode: 'label',
          callbacks: {
            label: function (tooltipItem, data) {
              let name = data.datasets[tooltipItem.datasetIndex].label
              let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
              let total = 0
              for (let i = 0; i < data.datasets.length; i++) {
                total += data.datasets[i].data[tooltipItem.index]
              }
              if (tooltipItem.datasetIndex !== data.datasets.length - 1 || data.datasets.length === 1) {
                return name + ': ' + value
              } else {
                return [name + ': ' + value, 'Total : ' + total]
              }
            }
          }
        },
        scales: {
          yAxes: [{
            stacked: true,
            ticks: {
              beginAtZero: true
            }
          }],
          xAxes: [{
            stacked: true
          }]
        }
      }
    })
  },
  methods: {
    async refresh () {
      if (this.dataSet.length > 0 && this.dataSet[0].data.length > 0 && this.chart.data) {
        this.chart.data.datasets = this.dataSet
        this.chart.data.labels = this.labels
        await this.$nextTick()
        this.chart.update(1000)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Chart.vue